export default {"src":"/_next/static/media/process-arrow.98aecd73.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};